import { SVGProps } from 'react';

export const StarsIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="19"
    height="16"
    viewBox="0 0 19 16"
    fill="none"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M14.125 7.62479L12.6249 3.625L11.1248 7.62479L7.125 9.12488L11.1248 10.625L12.6249 14.6248L14.125 10.625L18.1248 9.12488L14.125 7.62479Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M3.87518 3.00018L0.875 4.12491L3.87518 5.24963L4.99991 8.24982L6.12601 5.24963L9.12482 4.12491L6.12601 3.00018L4.99991 0L3.87518 3.00018Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M3.307 12.182L1.125 13L3.307 13.818L4.125 16L4.944 13.818L7.125 13L4.944 12.182L4.125 10L3.307 12.182Z"
      fill="currentColor"
    />
  </svg>
);
